export {PayeeLogosView} from 'src/PayeeLogosView/PayeeLogosView';
